var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivePOs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.5556 20.4444C25.5556 21.1222 25.2863 21.7722 24.807 22.2515C24.3278 22.7308 23.6778 23 23 23H2.55556C1.87778 23 1.22776 22.7308 0.748505 22.2515C0.269245 21.7722 0 21.1222 0 20.4444V2.55556C0 1.87778 0.269245 1.22776 0.748505 0.748505C1.22776 0.269245 1.87778 0 2.55556 0H8.94444L11.5 3.83333H23C23.6778 3.83333 24.3278 4.10258 24.807 4.58184C25.2863 5.0611 25.5556 5.71111 25.5556 6.38889V20.4444Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94531 12.7812L12.7786 16.6146L16.612 12.7812",
    stroke: "var(--arrow-color, white)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7773 8.94531V16.612",
    stroke: "var(--arrow-color, white)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivePOs);
export default __webpack_public_path__ + "static/media/InactivePOs.fe848bf4c89200e398fde04231891d1e.svg";
export { ForwardRef as ReactComponent };